import React, { Component } from 'react';
import { Modal, message } from 'antd';
import FormList from '../../../basicElement/FormList';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';

class FeedbackOpinion extends Component {
    state = {
        data: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        this.setState({
            visible: true,
            data: {
                isCoopreaionWithJinshi: '0',
                ...record,
            },
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (value, key, type) => {
        const { data } = this.state;
        data[key] = value;
        this.setState({ data });
    }

    getColumns = () => {
        const { data } = this.state;

        // 字段属性配置
        const columns = [{
            name: '报价单号',
            key: 'quotationNum',
            type: 'text',
        }, {
            name: 'Salesforce ID',
            key: 'salesforceId',
            type: 'text',
        }, {
            name: '报价单指导价',
            key: 'guidePrice',
            type: 'text',
        }, {
            name: '报价单总价',
            key: 'totalPrice',
            type: 'text',
        }, {
            name: '报价单版本',
            key: 'version',
            type: 'text',
        }, {
            name: '客户修改意见',
            key: 'opinion',
            type: 'textArea',
            typeProperty: {
                rows: 6,
                limit: 255,
                style: { width: 400 },
            },
            rules: {
                required: true,
            }
        }, {
            name: '附件',
            key: 'fileList',
            type: 'upload',
            typeProperty: {
                params: {},
                uploadUrl: API_URL.user.uploadUserAwardFile,
                removeUrl: API_URL.user.deleteUserAwardFile,
            },
        }];

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key, type, children, rules = {} } = column;
                if (children) {
                    traverseColumns(children);
                } else {
                    const typeProperty = column.typeProperty || (column.typeProperty = {});
                    typeProperty.canEdit = true;
                    if (type === 'upload') {
                        typeProperty.value = data[key] || [];
                    } else {
                        typeProperty.value = data[key];
                    }
                }
            });
        }
        traverseColumns(columns);

        return columns;
    }

    confirm = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;

        const { data } = this.state;
        const { opinion, fileList } = data;
        const files = {};
        if (fileList.length) {
            fileList.forEach((item, index) => {
                files[`ids[${index}]`] = item.response.fileMetaId;
            });
        }
        this.setState({ loading: true });
        Fetch.post(API_URL.competeCompany.addRegistrationStart, {
            opinion,
            ...files,
        }).then(res => {
            message.success(res.success);
            this.setState({
                visible: false,
                loading: false,
            }, () => {
                this.props.loadData();
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    render() {
        const { loading, visible } = this.state;
        return (
            <Modal
                title="反馈客户修改意见"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                maskClosable={false}
                width="600px"
                confirmLoading={loading}
                bodyStyle={{ maxHeight: 500 }}
            >
                <div style={{ margin: '10px 0' }}>
                    <FormList
                        className="form-list feedbackOpinion-list"
                        columns={this.getColumns()}
                        onChange={this.handleChange}
                        ref={el => this.formRef = el}
                    />
                </div>
            </Modal>
        );
    }
}

export default FeedbackOpinion;


// WEBPACK FOOTER //
// ./src/components/quotation/list/Components/FeedbackOpinion.js